/* This is the emis community components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 63px" width="800" border="1px;" cellspacing="0px;">
        <tbody>
          <tr style="height: 31px">
            <td
              style="
                width: 350px;
                height: 87px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយ
            </td>
            <td
              style="
                width: 70px;
                height: 62px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              អត្ថិភាព
            </td>
            <td
              style="
                width: 100px;
                height: 31px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ចំនួនសមាជិក
            </td>
            <td
              style="
                width: 200px;
                height: 62px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
              colspan="2"
            >
              សរុប
            </td>
          </tr>
          <tr style="height: 31px">
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
          </tr>

          <tr
            v-for="(value, row) in comDesc.length"
            :key="row"
            style="height: 25px"
          >
            <td
              style="
                width: 200px;
                height: 87px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ comDesc[row] }}
            </td>
            <td
              style="
                width: 70px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                class="py-0 px-1"
                v-model="data[row].dt[0]"
                hide-details
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                @keypress.native="onSelect($event)"
              >
              </v-select>
            </td>
            <td class="td-row-data">
              <numberinput v-model="data[row].dt[1]" class="number" />
            </td>
            <td class="td-row-data">
              <numberinput v-model="data[row].dt[2]" class="number" />
            </td>
            <td
              style="
                width: 150px;
                height: 87px;
                text-align: right;
                vertical-align: middle;
              "
            >
              {{ comDesc2[row] }}
            </td>
            <td class="td-row-data">
              <numberinput v-model="data[row].dt[3]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { yesNo6 } from "@/utils/ascf/commonConfig.js";
import { comDesc, comDesc2 } from "@/utils/priascf/comPreVariables.js";

export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      yesNo6: yesNo6,
      comDesc: comDesc,
      comDesc2: comDesc2,
    };
  },
  methods: {
    onSelect: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.td-row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 13px;
}
</style>